// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectSession,
    selectCurrentBanner,
} from '../../../features/session/sessionSlice';

// Components
import Loading from '../../templates/StateScreen/Loading';
import SessionScreen from '../../organisms/SessionScreen/SessionScreen';
import SessionIdle from '../../molecules/SessionIdle/SessionIdle';
import Banner from '../../molecules/Banner/Banner';
import Countdown from '../../atoms/Countdown/Countdown';
import Lead from '../../atoms/Lead/Lead';

// Hooks
import useCountdownTimer from '../../../hooks/useCountdownTimer';

/**
 * @function SessionStarting
 * Countdown to session starting with advertisement
 *
 * @example
 * return (
 *   <SessionStarting />
 * )
 */
function SessionStarting(): JSX.Element {
    const session = useAppSelector(selectSession);
    const currentBanner = useAppSelector(selectCurrentBanner);
    if (session === null || session === undefined) return <></>;
    const startTime = new Date(`${session.start_at}`);
    const timeDiff = useCountdownTimer(startTime);

    if (timeDiff <= 0) {
        return <Loading text="Loading session..." />;
    }

    return (
        <SessionScreen>
            <SessionIdle>
                <Lead>
                    {session?.games.length > 1 ? (
                        <>Game 1 starts in</>
                    ) : (
                        <>Game starts in</>
                    )}
                </Lead>
                {!Number.isNaN(timeDiff) && <Countdown time={timeDiff} />}
                {session.banners.length > 0 && (
                    <Banner
                        name={session.banners[currentBanner].name}
                        link={session.banners[currentBanner].link}
                        image={`https://cdn.zentrl.io/target-adverts/banners/${session.banners[currentBanner].image}`}
                        text={session.banners[currentBanner].text}
                    />
                )}
            </SessionIdle>
        </SessionScreen>
    );
}

// Exports
export default SessionStarting;
